import { render, staticRenderFns } from "./SectionDesc.vue?vue&type=template&id=85266e0e&"
import script from "./SectionDesc.vue?vue&type=script&lang=js&"
export * from "./SectionDesc.vue?vue&type=script&lang=js&"
import style0 from "./SectionDesc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports